import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMessage, tokenStore } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { usePageMeta } from "@/lib/format";
import { useT } from "@/i18n";
import { AuthShell } from "@/components/auth/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "@/components/ui/sonner";

export default function Reset() {
  const t = useT();
  usePageMeta(t("rp.meta"));
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, new_password: pw });
      tokenStore.set(data);
      setUser(data.user);
      toast.success(t("rp.updated"));
      navigate("/app", { replace: true });
    } catch (err) {
      toast.error(errMessage(err, t("rp.failed")));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title={t("rp.title")}
      subtitle={t("rp.subtitle")}
      footer={<><Link to="/login" className="font-medium text-primary hover:underline">{t("rp.back")}</Link></>}
    >
      {!token ? (
        <p className="text-sm text-muted-foreground" data-testid="reset-no-token">
          {t("rp.no_token")}
        </p>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4" data-testid="reset-form">
          <div className="space-y-1.5">
            <Label htmlFor="pw">{t("rp.new_pw")}</Label>
            <Input id="pw" type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} placeholder={t("rp.pw_ph")} data-testid="reset-password" />
          </div>
          <Button type="submit" className="w-full rounded-full" size="lg" disabled={loading} data-testid="reset-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : t("rp.submit")}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
